import { FieldValues, UseFormGetValues, UseFormSetValue, Path, PathValue } from "react-hook-form";

export type PastedImageDocument = {
  id: string | number;
  file: File;
  fileName: string;
  currentFileUrl: string;
};

interface HandlePastedImageUploadProps <
  TFieldValues extends FieldValues,
  TFieldName extends Path<TFieldValues>
>{
  event: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement>,
  uploadBlob: (data: { file: File, filename: string }) => Promise<any>,
  getValues: UseFormGetValues<TFieldValues>,
  setValue: UseFormSetValue<TFieldValues>,
  fieldName: TFieldName,
}

export const handlePastedImageUpload = async <
  TFieldValues extends FieldValues,
  TFieldName extends Path<TFieldValues>
>({
  event, 
  uploadBlob,
  getValues,
  setValue,
  fieldName
}: HandlePastedImageUploadProps<TFieldValues, TFieldName>) => { 
  const files = Array.from(event.clipboardData.files || [])
  
  if (files.length > 0) {
    event.preventDefault();

    for (const file of files) {
      const data = await uploadBlob({ file, filename: file.name })
      
      if (data?.data?.data?.id) {
        const currentDocuments = (getValues(fieldName) as PastedImageDocument[]) || [];
        
        const newDocument: PastedImageDocument = {
          id: data.data.data.id,
          file,
          fileName: file.name,
          currentFileUrl: URL.createObjectURL(file),
        };

        setValue(
          fieldName,
          [...currentDocuments, newDocument] as PathValue<TFieldValues, TFieldName>,
          { shouldValidate: true }
        );
      }
    }
  }
}